import { assert, Struct } from "superstruct"
import { blobToText } from "./blobToText"

export const blobToJson = async <T>(blob: Blob, schema: Struct<T>) => {
  const data = JSON.parse(await blobToText(blob))
  assert(data, schema)
  return data
}
